import { createContext, useContext, useEffect, useState } from "react";
import API from "../api";
import { ROLES } from "../constants/roles";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data } = await API.get("/auth/me");

        // Ensure role and leagueid are set
        if (!data.role) data.role = ROLES.USER;
        if (!data.leagueid) data.leagueid = null;

        setUser(data);
      } catch {
        setUser(null);
      } finally {
        setLoading(false);
      }
    };
    checkSession();
  }, []);

  // Utility method to check minimum role
  const hasRole = (minRole) => {
    return user?.role >= minRole;
  };

  // Helper aliases for clarity
  const isUser = hasRole(ROLES.USER);
  const isLeagueAdmin = hasRole(ROLES.LEAGUE_ADMIN);
  const isAppAdmin = hasRole(ROLES.APP_ADMIN);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        loading,
        hasRole,
        isUser,
        isLeagueAdmin,
        isAppAdmin
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
